<template>
    <ClientLayout v-if="user">
        <v-toolbar app fixed color="primary">
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn flat class="white--text" @click="nav('/resources')">Resources</v-btn>
                <v-divider vertical class="mx-3"></v-divider>
                <v-btn flat class="white--text" @click="nav('/glossary')">Glossary</v-btn>
                <v-divider vertical class="mx-3"></v-divider>
                <v-btn flat class="white--text" @click="nav('/logout')">Log Out</v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
        </v-toolbar>
        <HomeNav v-for="(id, index) in sectionOrder" :key="index" :id="`section${id}`" :section="id" @loaded="autoscroll"></HomeNav>
    </ClientLayout>
</template>

<script>
import goTo from 'vuetify/lib/components/Vuetify/goTo';
import router from '@/router';
import HomeNav from '@/components/HomeNav';
import { get } from 'vuex-pathify';
import { debounce } from 'lodash';

export default {
    name: 'Home',
    components: { HomeNav },
    computed: {
        user: get('user'),
        sectionOrder: get('sectionOrder'),
        firstIncompleteSection: get('firstIncompleteSection')
    },
    mounted() {
        this.$nextTick(() => {
            this.autoscroll();
        });
    },
    methods: {
        nav(to) {
            router.push(to);
        },
        autoscroll: debounce(function() {
            if (this.user && this.firstIncompleteSection) {
                goTo(`#section${this.firstIncompleteSection}`);
            }
        })
    }
};
</script>
